import { Transition } from '@headlessui/react'
import { CheckCircleIcon, XIcon } from '@heroicons/react/outline'
import { Fragment } from 'react'

function SuccessNoticeCenter({ children, onRemove }) {
    return (
        <div
            aria-live="assertive"
            className="fixed z-20 inset-0 flex items-center px-4 py-6 pointer-events-none sm:p-6 sm:items-center">
            <div className="w-full flex flex-col items-center space-y-4 sm:items-center">
                {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                <Transition
                    show={true}
                    as={Fragment}
                    enter="transform ease-out duration-300 transition"
                    enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                    enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0">
                    <div className="max-w-sm w-full">
                        <div className="max-w-sm w-full bg-olm-green text-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                            <div className="p-4">
                                <div className="flex items-center ">
                                    <div className="flex-shrink-0">
                                        <CheckCircleIcon
                                            className="h-6 w-6"
                                            aria-hidden="true"
                                        />
                                    </div>
                                    <div className="ml-3 w-0 flex-1 pt-0.5">
                                        <p className="font-medium text-white">
                                            {children}
                                        </p>
                                    </div>
                                    <div className="ml-4 flex-shrink-0 flex">
                                        <button
                                            onClick={onRemove}
                                            type="button"
                                            className="bg-transparent text-white hover:bg-white hover:text-red-500 font-semibold flex items-center border border-transparent rounded-lg p-2 text-center cursor-pointer  focus:outline-none focus:ring-1 focus:ring-olh focus:border-olh sm:text-sm">
                                            <span className="sr-only">
                                                Close
                                            </span>
                                            <XIcon
                                                className="h-5 w-5"
                                                aria-hidden="true"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Transition>
            </div>
        </div>
    )
}

export default SuccessNoticeCenter
